import { render, staticRenderFns } from "./ProjectLayoutAside.vue?vue&type=template&id=1aba3948&scoped=true&"
import script from "./ProjectLayoutAside.vue?vue&type=script&lang=ts&"
export * from "./ProjectLayoutAside.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectLayoutAside.vue?vue&type=style&index=0&id=1aba3948&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aba3948",
  null
  
)

export default component.exports